import type {DesignAttachment, ImageAttachment, PromptAttachment} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import {PromptAttachmentType} from '@Components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import type {ReactElement} from 'react';
import styles from './prompt-attachments.module.scss';
import {getPosterPreviewURL} from '@Libraries/poster-library';
import {getImageScreenURL} from '@Libraries/image-item.library';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import {Image} from 'react-bootstrap';

interface PromptAttachmentProps {
  attachments: PromptAttachment[];
  removePromptAttachment: (index: number) => void;
}

export function PromptAttachments({attachments, removePromptAttachment}: PromptAttachmentProps): ReactElement {
  const getImageAttachmentPreview = (attachment: ImageAttachment, index: number): ReactElement => {
    const imageUrl = getImageScreenURL(attachment.hashedFilename, attachment.extension, attachment.source);

    return (
      <div key={index} className={styles.attachment}>
        <Image src={imageUrl} className={styles.attachmentItem} />
        <Icon
          className={styles.removeAttachmentButton}
          icon={'icon-close'}
          size={IconSize.SIZE_ICON_12}
          shape={IconShape.CIRCLE}
          onClick={() => {
            removePromptAttachment(index);
          }}
        />
      </div>
    );
  };

  const getDesignAttachmentPreview = (attachment: DesignAttachment, index: number): ReactElement => {
    const posterPreviewUrl = getPosterPreviewURL(attachment.designId);

    return (
      <div key={index} className={styles.attachment}>
        <Image src={posterPreviewUrl} className={styles.attachmentItem} />
        <Icon
          className={styles.removeAttachmentButton}
          icon={'icon-close'}
          size={IconSize.SIZE_ICON_12}
          shape={IconShape.CIRCLE}
          onClick={() => {
            removePromptAttachment(index);
          }}
        />
      </div>
    );
  };

  const getAttachmentPreview = (attachment: PromptAttachment, index: number): ReactElement => {
    switch (attachment.type) {
      case PromptAttachmentType.IMAGE:
        return getImageAttachmentPreview(attachment, index);
      case PromptAttachmentType.DESIGN:
        return getDesignAttachmentPreview(attachment, index);
    }
  };

  const getAttachments = (): ReactElement => {
    return <div className={styles.attachments}>{attachments.map((attachment, index) => getAttachmentPreview(attachment, index))}</div>;
  };

  return getAttachments();
}
